import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { getWdsSurfaceNeutralProps } from '../../../utils/wds-theme-colors';
export const RuleTipBox = _ref => {
  let {
    children,
    backgroundColor,
    padding = 'SP2 SP3',
    marginTop,
    dataHook = 'rule-tip-box',
    useSurfaceNeutral = true
  } = _ref;
  const surfaceProps = useSurfaceNeutral ? getWdsSurfaceNeutralProps() : {
    backgroundColor: backgroundColor ?? 'B60'
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    borderRadius: "6px",
    dataHook: dataHook,
    marginTop: marginTop,
    padding: padding,
    width: "100%"
  }, surfaceProps), children);
};
//# sourceMappingURL=rule-tip-box.js.map